import { startPhase1BackgroundRecovery } from "./phase1BackgroundRecovery";
import { patchFromRun } from "./phase1StreamPatch";
import { patchPhase1Error, patchPhase1Interrupted } from "./phase1StreamError";
import { publishArtifactDocuments } from "./publishArtifactDocuments";

export function settlePhase1Stream(ctx, run) {
  if (ctx.signal.aborted) {
    patchPhase1Interrupted(ctx, run);
    return;
  }
  if (run.status === "done") {
    patchFromRun(ctx, run, { demoStreamActive: false, text: run.text || "" });
    publishArtifactDocuments(ctx.tid, run.blocks);
    return;
  }
  if (run.status === "error") {
    patchPhase1Error(ctx, new Error(run.error?.message), run);
    return;
  }
  if (run.runId) {
    startPhase1BackgroundRecovery(ctx, run);
    return;
  }
  patchPhase1Interrupted(ctx, run);
}
